module.exports = __webpack_public_path__ + "img/9.367256fa.png";